export enum ThemeEnum {
  light = "light",
  dark = "dark",
}
